import { getItemOrDefaultToValue } from 'utils/details';
import {
  transportServiceOption,
  vehicleCategoryOption,
} from 'containers/Pages/Tasks/TripTypes/Layouts/options';
import { convertToDecimal } from 'utils/DataTransform/utils/index.js';
import { getPriceInDollars } from './tripType';
import { BASE_ASSET_CATEGORY } from 'utils/constants/assetText';
import { serviceTypes } from 'utils/constants/serviceTypes';

export const transform = tripTypeData => {
  const serviceType = getItemOrDefaultToValue(tripTypeData, 'serviceType');
  const displayName = transportServiceOption.find(f => f.id === serviceType);
  return {
    generalInfo: {
      serviceType: {
        type: 'text',
        value: displayName?.name ? displayName.name : '-',
      },
      vehicleCategory: {
        type: 'text',
        value: getItemOrDefaultToValue(tripTypeData, 'vehicleCategory'),
      },
      vehicleType: {
        type: 'text',
        value: getItemOrDefaultToValue(tripTypeData, 'vehicleType'),
      },
    },
    detailedInfo: {
      srFlagFall: {
        type: 'text',
        value: getPriceInDollars(
          getItemOrDefaultToValue(tripTypeData, 'srFlagFall', '-'),
          tripTypeData.currency,
        ),
      },
      srSharePercentOnCost: {
        type: 'text',
        value: getItemOrDefaultToValue(
          tripTypeData,
          'srSharePercentOnCost',
          '-',
        ),
      },
      flagFall: {
        type: 'text',
        value: getPriceInDollars(
          getItemOrDefaultToValue(tripTypeData, 'flagFall', '-'),
          tripTypeData.currency,
        ),
      },
      costPerKM: {
        type: 'text',
        value: getPriceInDollars(
          getItemOrDefaultToValue(tripTypeData, 'costPerKM', '-'),
          tripTypeData.currency,
        ),
      },
      costPerMin: {
        type: 'text',
        value: getPriceInDollars(
          getItemOrDefaultToValue(tripTypeData, 'costPerMin', '-'),
          tripTypeData.currency,
        ),
      },
    },
    others: {
      id: {
        value: tripTypeData.id,
      },
    },
  };
};

const getServiceTypeId = serviceTypeName => {
  const data = transportServiceOption.find(
    transportService => transportService.name === serviceTypeName,
  );
  if (data) {
    return data.id;
  } else {
    return serviceTypes.transport.standard; //need to remove this on removing seeded incorrect data
  }
};
const getVehicleTypeId = vehicleTypeName => {
  const data = vehicleCategoryOption.find(
    vehicleType => vehicleType.name === vehicleTypeName,
  );
  if (data) {
    return data.id;
  } else {
    return BASE_ASSET_CATEGORY.VEHICLE.id; //need to remove this on removing seeded incorrect data
  }
};

export const transformTripDataForForm = trip => {
  return {
    ...trip,
    costPerMin: convertToDecimal(trip.costPerMin, trip.currencySymbol),
    costPerKM: convertToDecimal(trip.costPerKM, trip.currencySymbol),
    flagFall: convertToDecimal(trip.flagFall, trip.currencySymbol),
    srFlagFall: convertToDecimal(trip.srFlagFall, trip.currencySymbol),
    srSharePercentOnCost: convertToDecimal(
      trip.srSharePercentOnCost,
      trip.currencySymbol,
    ),
    serviceType: getServiceTypeId(trip.serviceType),
    vehicleType: trip.vehicleType,
    vehicleCategory: getVehicleTypeId(trip.vehicleCategory),
  };
};
